import { initializeApp } from 'firebase/app';
import { getAnalytics, isSupported } from 'firebase/analytics';

// Firebase web config is read from Vite env vars at build time. The fallbacks
// below are the *current production values* for the `agency-5e9cb` project.
//
// Why ship them inline as fallbacks?
//   1. Firebase web `apiKey` is *public-by-design* — it's a project identifier,
//      not a secret. Real auth is enforced by Firebase API-key referrer
//      restrictions (Google Cloud Console) + Firestore/Storage security rules.
//   2. Keeping fallbacks here lets `npm run dev` / CI run without a .env file.
//      Override per-environment by populating `.env.local` (gitignored) with
//      the keys documented in `.env.example`.
const env = import.meta.env;
const firebaseConfig = {
  apiKey: env.VITE_FIREBASE_API_KEY ?? 'AIzaSyDWXLREWV9UzCVTJ2aIJCTFXQKCNIFv7Hc',
  authDomain:
    env.VITE_FIREBASE_AUTH_DOMAIN ?? 'agency-5e9cb.firebaseapp.com',
  projectId: env.VITE_FIREBASE_PROJECT_ID ?? 'agency-5e9cb',
  storageBucket:
    env.VITE_FIREBASE_STORAGE_BUCKET ?? 'agency-5e9cb.firebasestorage.app',
  messagingSenderId:
    env.VITE_FIREBASE_MESSAGING_SENDER_ID ?? '952482708475',
  appId:
    env.VITE_FIREBASE_APP_ID ?? '1:952482708475:web:3df30b3f68940c5217e95e',
  measurementId: env.VITE_FIREBASE_MEASUREMENT_ID ?? 'G-FEY1KSKR6H',
};

export const app = initializeApp(firebaseConfig);

// Analytics only loads in browsers that support it (no SSR / no unsupported envs)
isSupported()
  .then((ok) => {
    if (ok) getAnalytics(app);
  })
  .catch(() => {
    /* analytics unavailable — silently skip */
  });
